import React, { useState, useEffect } from 'react';
import {
  Form, FormGroup, Input, Button,Row, Col
} from 'reactstrap';
import LaddaButton, { EXPAND_RIGHT } from 'react-ladda';
import PropTypes from 'prop-types';

import { KYCConstants, getAccountType } from '../types';
import { CustomFormInput, FormField } from '../../../../utils/FormFields';
import { CircularProgress } from '../../../..';
import { AccountMode } from '../../../../utils/Helper';
import ModalConfirm from "../../Modal/ModalConfirm";


const FinalizeTab = ({
  Finalize,
  accountId,
  account,
  setAccountData,
  setRedirectAccount,
  services,
  mode,
  userType,
}) => {
  const [loadingSave, setLoadingSave] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [loadingCheck, setLoadingCheck] = useState(false);
  const [personlist, setPersonList] = useState([]);
  const [showResults, setShow] = useState(false);
  const [listResults, setResults] = useState([]);
  const [reportId, setReportid] = useState(0)
  const [modalConfirm, setModalConfirm] = useState({
    open: false,
    title: "",
    callback: undefined,
    loading: false,
    accountId: undefined
  });



  const handleCreateAccount = () => {
    setLoadingSave(true)
    const body = {
      onboardingProcessId: accountId,
    }
    services.createAccount(body, (data) => {
      if (data && data.result) {
        if (data.result.Code === 200) {
          alert(data.result.Description);
          setRedirectAccount(data.id);
        } else {
          if(data.result.Description.includes("FundsX")){
            alert(data.result.Description);
            setRedirectAccount(data.id);
          }else {
            alert(`Failed! ${data.result.Description}`);
          }
          
        }
      }
      setLoadingSave(false);
    });
  }
  
  const createOnboardingAccount = () => {
    setModalConfirm(m => ({
      ...m,
      open: true,
      title: "Are you sure you want to send account information?",
      accountId,
      callback: () => handleCreateAccount()
    }));
  };


  const listCheck = () => {
    setLoadingCheck(true)
    const body = {
     sdtApproveAccount: personlist,
     fromType: 'EasyAccount',
    }
    if (personlist.length < 1){
      alert("There aren't people to check!");
    }else{
    services.AccountListCheck(body, (data) => {
      if (data && data.error) {
        if (data.error.lenght > 0) {
          setResults(data.error);
          
        } 
        setReportid(data.logListId);
      }
      setLoadingCheck(false);
    });
  }
  }


  useEffect(() => {
    setLoadingData(true);
      const body = {
        AccountGetInfo: {
          GetAccountDataOnboardingId: accountId,
          GetAccountDataId: accountId,
          GetAccountDataType: getAccountType.Finalize,
        },
      };
      if (mode === AccountMode.New) {
        services.fetchNewAccountInfo(body, (data) => {
          if (data && data.SDTAccount) {
            setLoadingData(false);
            setPersonList(data.SDTAccount.SDTApproveAccount)
          }else{
            setLoadingData(false);
          }
        });
      }
   
  }, []);

  const toggleModalConfirm = () =>
    setModalConfirm({
      open: false,
      title: "",
      accountId: undefined,
      callback: undefined,
      loading: false
    });

    const handleDownload = () => {
      services.getReportListCheck({
        logListId: reportId
      }).then(response => {
        window.open(response.response.url);
      });
    };
    // markAsFalsePositive(name, personId, marked) {
    //   var message = "";
    //   if (marked == false) {
    //     message =
    //       "Are you sure you want to mark person " + name + " as false positive?";
    //   } else {
    //     message =
    //       "Are you sure you want to unmark person " +
    //       name +
    //       " as false positive?";
    //   }
    //   this.setState({
    //     modalPersonId: personId,
    //     openModalConfirm: true,
    //     modalMessage: message,
    //     markModal: marked
    //   });
    // }
  

//   const handleSave = () => {
//     const Finalize = { ...Finalize };
//     const body = {
//       account: {
//         AccountId: accountId,
//         AccountOnboardingId : accountId,
//         KYC: newKYC,
//       },
//       accountChangeType: getAccountType.KYC,
//     };
//     setLoadingSave(true);
//     if (mode === AccountMode.New){
//       services.fetchNewAccount(body, (res) => {
//         if (res){
//           setAccountData({
//             AccountId: account.AccountOnboardingId,
//             KYC: newKYC,
//           }, true);
//           setChangedKYC({});
//           setLoadingSave(false);
//         }else{
//           setLoadingSave(false);
//         }
//       })
//     }else{
//     services.fetchAccountUpdate(body, ({ result }) => {
//       if (result && result.Code === 200) {
//         setAccountData({
//           AccountId: accountId,
//           KYC: newKYC,
//         }, true);
//         setChangedKYC({});
//         setLoadingSave(false);
//       } else {
//         setLoadingSave(false);
//       }
//     });
//   };
// }

  // const onChange = (name, value) => {
  //   if (!loadingSave) {
  //     const newKYC = { ...changedKYC };
  //     if (KYC[name] !== value) {
  //       newKYC[name] = value;
  //     } else if (newKYC[name]) {
  //       newKYC[name] = undefined;
  //     }
  //     setChangedKYC(newKYC);
  //   }
  // };

  //const revert = () => setChangedKYC({});


 if (loadingData) {
    return <CircularProgress sm />;
  }
  return (
    <div>
      <Row>
      {/* <Col md="7">
            <span style={{float: "left", fontSize: "18px"}}>Do you want to List check Account? </span>
      </Col>
      <Col style={{textAlign: "right"}}>
        <LaddaButton
              className="btn btn-ladda btn-primary"
              loading={loadingCheck}
              onClick={listCheck}
              data-style={EXPAND_RIGHT}
            >
             List Check
            </LaddaButton>
      </Col> */}
      <Col>
      {reportId > 0 &&
       <Button
       onClick={handleDownload}
       style={{marginRight: "10px"}}
     >
       {" "}
       <i className="fa fa-file-pdf-o" />
     </Button>
    }
     </Col>
     </Row>
     <Row className="my-3"> 
            <div>
              
            </div>
          </Row>
     {/* <Col md="7">
            <span style={{float: "left", fontSize: "18px"}}>Download Account Info </span>
      </Col> */}

      {/* <Col style={{textAlign: "right"}}>
       <Button
       onClick={handleDownload}
       style={{marginRight: "220px"}}
     >
       {" "}
       <i className="fa fa-file-pdf-o" />
     </Button>
     </Col> */}
     <Row>


     </Row>

<Row xl="4">
     
      {showResults && 
      <Table>
      <thead>
        <tr>
          <th>Person Name</th>
          <th>Person Checked Name</th>
          <th>List Name</th>
          <th>Person Relation</th>
          <th style={{textAlign: "right"}}>Marked as false positive</th>
        </tr>
      </thead>
      <tbody>
        {listResults.map((r, i) => (
          <tr key={`set-${r.id}`}>
            <td>{r.personName}</td>
            <td>{r.personCheckName}</td>
            <td>{r.listName}</td>
            <td>{r.personRelation}</td>
            <td>
              {r.belongPersonList == true ? (
                <Button
                  style={{float: "right"}}
                  color="primary"
                  outline
                  onClick={() =>
                    markAsFalsePositive(r.personName, r.id, false)
                  }
                >
                  Unmark as false positive
                </Button>
              ) : (
                <Button
                  style={{float: "right"}}
                  color="primary"
                  outline
                  onClick={() =>
                    markAsFalsePositive(r.personName, r.id, true)
                  }
                >
                  Mark as false positive
                </Button>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
    }
    </Row>
      <Row style={{textAlign: "right"}}> 
        {/* {userType === 'Compliance' && */}
        
    
        <Col style={{textAlign: "right"}}>
        <LaddaButton
              className="btn btn-ladda btn-primary"
              loading={loadingSave}
              onClick={createOnboardingAccount}
              data-style={EXPAND_RIGHT}
            >
              Create Account
            </LaddaButton>
        </Col>
      </Row>
      <ModalConfirm
        open={modalConfirm.open}
        toggle={toggleModalConfirm}
        title={modalConfirm.title}
        callback={modalConfirm.callback}
        saving={loadingSave}
      />
    </div>
  );
};

FinalizeTab.propTypes = {
  accountId: PropTypes.string.isRequired,
  setAccountData: PropTypes.func.isRequired,
  services: PropTypes.object.isRequired,
  account: PropTypes.object.isRequired,
  mode: PropTypes.object.isRequired,
};

FinalizeTab.defaultProps = {
  Finalize: undefined,
};

export default FinalizeTab;
